export default {
  current: '',
  events: [],
  categories: [],
  eventComments: [],
  reportedComments: []
};
